/**
 * Created by kevin on 2016-12-13.
 */

import { Component, Input } from '@angular/core';


@Component({
  selector: 'edx-list-info-footer',
  styleUrls: ['list-info-footer.component.scss'],
  template: `
    <div class="main">
      @if (heading) {
        <div class="header">{{heading}}</div>
      }
      @for (item of displayItems; track item) {
        <div class="item">
          @if (item.label) {
            <div class="label">{{item.label}}</div>
          }
          @if (item.label) {
            <span>:</span>
          }
          <div class="value">{{item.value}}</div>
        </div>
      }
    </div>
    `,
  standalone: false
})
export class ListInfoFooterComponent {
  @Input() heading?: string = null;
  @Input() displayItems?: FooterDisplayItem[] = null;
}

export class FooterDisplayItem {
  label?: string;
  value: string;
}
